
import React, {FC} from 'react';
import {Metric, RegionOrder, Result} from 'templates/reports/Section/RegionalComp/parse';

import {Row} from './Row';

import * as styles from './styles.module.scss';

type TableProps = {
	metric: Metric
	result: Result
}

export const Table: FC<TableProps> = (props) => {
	return (
		<div className={styles.table}>
			{RegionOrder.map((r) => (
				<Row region={r} {...props} key={r} />
			))}
			<Row region='total' {...props} />
		</div>
	);
};
